import type { Layer } from '@/types/api';
import { currentLanguage } from '@/i18n/format';

/** translationName's old order: [en, tr, nl, de]. */
const OLD_ORDER = ['en', 'tr', 'nl', 'de'];

/**
 * A layer's name in the current language: its labels (every language the registry has), else the old
 * translationName list, then English, then Turkish, then the name the server gave, then the GeoServer name.
 */
export function layerLabel(layer: Pick<Layer, 'labels' | 'translationName' | 'displayName' | 'layerName'>): string {
  const lang = currentLanguage();
  const fromOld = (code: string) => {
    const i = OLD_ORDER.indexOf(code);
    return i >= 0 ? layer.translationName?.[i] : undefined;
  };
  const pick = (code: string) => (layer.labels?.[code] || fromOld(code) || '').trim();
  return pick(lang) || pick('en') || pick('tr') || layer.displayName || layer.layerName;
}
